<div id="protocol" *ngIf="!loading; else loadingTemplate" [class.protocol-panel--collapsed]="collapsed">
  <ng-container *ngFor="let pipeline of pipelines">
    <div class="widget stat" *ngIf="!collapsed">
      <span>{{ pipeline?.names?.[lang] ?? pipeline?.names?.en }}</span>
    </div>
    <ng-container *ngFor="let categoryId of pipeline.categories">
      <mat-expansion-panel *ngIf="categories[categoryId] as category" [expanded]="true" hideToggle>
        <mat-expansion-panel-header [class.protocol-panel__header--collapsed]="collapsed">
          <mat-panel-title>
            <ng-container *ngIf="!collapsed">
              <ng-container *ngTemplateOutlet="sectionTemplate; context: { $implicit: category }"></ng-container>
            </ng-container>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="protocol-panel__cell-list">
          <ng-container *ngFor="let optionId of category.options">
            <div
              *ngIf="options[optionId] as label"
              #label
              class="protocol-panel__row"
              [id]="label.id"
              (click)="selectLabel(label)"
            >
              <ng-container
                *ngTemplateOutlet="labelTemplate; context: { $implicit: { label, category } }"
              ></ng-container>
            </div>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </ng-container>
</div>
<ng-template #loadingTemplate>
  <div class="widget stat">
    <span>{{ 'core.loading' | translate }}...</span>
  </div>
</ng-template>
